import React from 'react';
import { industries } from '../mock';
import * as Icons from 'lucide-react';

export default function Industries() {
  return (
    <section id="industries" className="relative overflow-hidden">
      {/* Full-bleed image band with overlay */}
      <div className="relative">
        <img
          src="https://images.unsplash.com/photo-1541888946425-d81bb19240f5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHwxfHxjb25zdHJ1Y3Rpb24lMjB3b3JrZXJ8ZW58MHx8fHwxNzg0ODAwOTQxfDA&ixlib=rb-4.1.0&q=85"
          alt="Industries we serve"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-[#0e1421]/85" />

        <div className="relative z-10 max-w-[1400px] mx-auto px-6 lg:px-10 py-24 md:py-28">
          <div className="text-center mb-14 max-w-3xl mx-auto">
            <span className="jh-eyebrow text-white" style={{ color: '#fff' }}>
              Industries We Serve
            </span>
            <h2 className="jh-h2 text-white mt-4">
              A Deep Talent Pool Across 13+ Industries
            </h2>
            <p className="text-white/75 mt-5 leading-relaxed">
              John Herbert Limited recruits professionals and skilled workers
              for a broad range of industries — backed by rigorous screening,
              verification and pre-departure training.
            </p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
            {industries.map((ind) => {
              const Icon = Icons[ind.icon] || Icons.Briefcase;
              return (
                <div
                  key={ind.name}
                  className="group rounded-lg border border-white/10 bg-white/[0.04] p-5 hover:bg-[#E11D2E] hover:border-[#E11D2E] transition-colors duration-300 flex flex-col items-center text-center"
                >
                  <div className="w-14 h-14 rounded-full bg-white/10 group-hover:bg-white/15 flex items-center justify-center mb-3 transition-colors">
                    <Icon size={26} className="text-white" strokeWidth={1.6} />
                  </div>
                  <span className="text-white font-semibold text-[14px] leading-tight">
                    {ind.name}
                  </span>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
